import PrivateImage from '../presentation/PrivateImage';
import React, {useEffect, useRef, useState} from "react";
import {Redirect, useParams} from "react-router-dom";
import UserService from "../../services/user.service";
import '../../Print.css';
import { logOut} from "../../helpers/logout";
import {Button, Divider, Grid, Toolbar} from "@material-ui/core";
import ActionButton from "../form/input/ActionButton";
import Tooltip from "@material-ui/core/Tooltip";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import GeneratedDocumentEmailAction from "./GeneratedDocumentEmailAction";
import BorderColorIcon from '@material-ui/icons/BorderColor';
import Popup from "../presentation/Popup";
import TextInput from "../form/input/TextInput";
import DateInput from "../form/input/DateInput";
import {PDFExport} from '@progress/kendo-react-pdf';
import {getPdfExportProxyProps, savePdfWithEmbeddedImages} from "../../helpers/pdfExport";
import Time from "react-time-format";
import {NotificationManager} from "react-notifications";
import withWidth from '@material-ui/core/withWidth'
import {ReactSketchCanvas} from "react-sketch-canvas";
import {convertSize} from "../../helpers/helper";
import {exportSignatureAsSvgBlob} from "../../helpers/signature";


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    seeMore: {
        marginTop: theme.spacing(8),
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
    toolbarButtons: {
        '& .MuiFormControl-root': {
            margin: theme.spacing(1)
        }
    },
    marginElement: {
        margin: theme.spacing(2)
    },
    marginTop: {
        marginTop: theme.spacing(2)
    },
    icon: {
        marginRight: theme.spacing(2),
    },
    heroContent: {
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(8, 0, 6),
    },
    heroButtons: {
        marginTop: theme.spacing(4),
    },
    cardGrid: {
        paddingTop: theme.spacing(8),
        paddingBottom: theme.spacing(8),
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
}));


const DelegationGenerator = (props) => {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper);
    let canvas = useRef(null);

    const pdfRef = useRef(null);
    const [funeral, setFuneral] = useState({
        contracting_authority: '',
        ca_address: '',
        ca_zip: '',
        ca_city: '',
        ca_state: '',
        ca_nationality: '',
        ca_email: '',
        ca_phone: '',
        ca_id: '',
        ca_birth: '',
        ca_relationship: '',
        deceased: '',
        d_address: '',
        d_zip: '',
        d_city: '',
        d_state: '',
        d_place_birth: '',
        d_birth: '',
        d_gender: '',
        d_marital_status: '',
        d_death: '',
        d_place_death: '',
        d_id: '',
        d_nationality: '',
        d_education: '',
        d_last_job: '',
        d_wife_husband: '',
        d_wife_husband_id: '',
        date_of_signature_delegation: new Date(),
        planned_pickup_place: '',
        planned_pickup: '',
        town_funeral: '',
        place_funeral: '',
        date_funeral: '',
        coffin_arrival: '',
        coffin_arrival_place: '',
        signatures: {}
    });
    const [show, setShow] = useState(false);
    const [date, setDate] = useState(new Date());
    const [location, setLocation] = useState('');
    const [success, setSuccess] = useState(false);
    const [fullScreen, setFullScreen] = useState(false);

    const handleShow = () => setShow(true);

    const handleDate = (e) => {
        setDate(e.target.value)
    }

    const handleLocation = (e) => {
        setLocation(e.target.value)
    }

    const [user, setUser] = useState(null);

    const funeral_id = useParams();
    const user_local = JSON.parse(localStorage.getItem('user')).id;

    useEffect(() => {
        UserService.getUser(user_local).then(
            (response) => {
                setUser(response.data);
                if (response.data.defined_texts) {
                    setLocation(response.data.defined_texts.default_signature_place);
                }
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
        UserService.getFuneral(funeral_id.funeral_id).then(
            (response) => {
                setFuneral(response.data);
            },
            (e) => {
                if (e.response.status === 401) {
                    logOut(props);
                    NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
                }
            }
        );
    }, [funeral_id.funeral_id, user_local, props]);

    const singleFileUploadHandler = (file) => {
        const data = new FormData();
        data.append('someimage', file, 'delegation_signature.svg');
        data.append('signatures_id', funeral.signatures._id);
        data.append('tag', 'delegation');
        data.append('date_of_delegation', new Date(date).toISOString());
        data.append('location_of_delegation', location);
        UserService.signDocument(data)
            .then((response) => {
                if (200 === response.status) {
                    // If file size is larger than expected.
                    if (response.data.error) {
                    } else {
                        let fileName = response.data;
                        setFuneral({
                            ...funeral,
                            'signatures': {...funeral.signatures, 'delegation_signature': fileName.location}
                        });
                        setShow(false);
                    }
                }
            }).catch((e) => {
            if (e.response.status === 401) {
                logOut(props);
                NotificationManager.warning('Potrebné sa znova prihlásiť!', 'Upozornenie', 5000);
            }
            NotificationManager.error('Nepodarilo sa podpísať dokument!', 'Chyba', 5000);
            setShow(false);
        });
    };

    const handleSignature = async () => {
        const exportSvg = canvas.current?.exportSvg;

        if (exportSvg) {
            try {
                const blob = await exportSignatureAsSvgBlob(canvas);
                singleFileUploadHandler(blob);
            } catch (e) {
                NotificationManager.error('Nepodarilo sa podpísať dokument!', 'Chyba', 5000);
                setShow(false);
            }
        }
    }

    const handleExport = () => {
        savePdfWithEmbeddedImages(pdfRef, (error) => {
            if (error) {
                NotificationManager.error('Nepodarilo sa exportovať PDF!', 'Chyba', 5000);
            }
        });
    }

    const handleClear = () => {
        const resetCanvas = canvas.current?.resetCanvas;

        if (resetCanvas) {
            resetCanvas();
        }
    }

    const showDelegation = () => {
        if (user) {
            return <div className="document-preview-frame" style={{border: '1px solid'}}>
                <PDFExport ref={pdfRef} {...getPdfExportProxyProps()} paperSize="A4" scale={0.75}
                           fileName={`splnomocnenie-${funeral.deceased.replace(' ', '')}`}>
                    <div className="a4-paper gendoc-doc">
                        {user.logo &&
                        <div className="gendoc-watermark-wrap">
                            <PrivateImage className="gendoc-watermark" src={user.logo} alt=""/>
                        </div>}
                        <div className="gendoc-body">
                            <header className="gendoc-header">
                                <div className="gendoc-header__eyebrow">{user.name}</div>
                                <h1 className="gendoc-title">Splnomocnenie</h1>
                                <div className="gendoc-subtitle">Objednávka pohrebu · Správa pre matriku</div>
                                <div className="gendoc-header__meta">
                                    {user.address} · IČO: {user.ico} · IČ DPH: {user.ic_dph} · Kontakt: {user.phone} · Email: {user.email_official}
                                </div>
                            </header>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Splnomocniteľ</h2>
                                <div className="gendoc-fields">
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Vybavuje</span>
                                        <span className="gendoc-value">{funeral.contracting_authority}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Rodné číslo</span>
                                        <span className="gendoc-value">{funeral.ca_id}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Adresa</span>
                                        <span className="gendoc-value">{funeral.ca_address} {funeral.ca_city} {funeral.ca_zip}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Dátum narodenia</span>
                                        <span className="gendoc-value"><Time value={funeral.ca_birth} format="DD.MM.YYYY"/></span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Tel. č.</span>
                                        <span className="gendoc-value">{funeral.ca_phone}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Príbuzenský vzťah</span>
                                        <span className="gendoc-value">{funeral.ca_relationship}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">E-mail</span>
                                        <span className="gendoc-value">{funeral.ca_email}</span>
                                    </div>
                                </div>
                            </section>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Zosnulý</h2>
                                <div className="gendoc-fields">
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Zosnulý</span>
                                        <span className="gendoc-value">{funeral.deceased}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Rodné číslo</span>
                                        <span className="gendoc-value">{funeral.d_id}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Pohlavie</span>
                                        <span className="gendoc-value">{funeral.d_gender}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Miesto narodenia</span>
                                        <span className="gendoc-value">{funeral.d_place_birth}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Národnosť</span>
                                        <span className="gendoc-value">{funeral.d_nationality}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Miesto úmrtia</span>
                                        <span className="gendoc-value">{funeral.d_place_death}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Dátum narodenia</span>
                                        <span className="gendoc-value"><Time value={funeral.d_birth} format="DD.MM.YYYY"/></span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Vzdelanie</span>
                                        <span className="gendoc-value">{funeral.d_education}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Dátum úmrtia</span>
                                        <span className="gendoc-value"><Time value={funeral.d_death} format="DD.MM.YYYY"/></span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Posledné zamestnanie</span>
                                        <span className="gendoc-value">{funeral.d_last_job}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Rodinný stav</span>
                                        <span className="gendoc-value">{funeral.d_marital_status}</span>
                                    </div>
                                </div>
                            </section>

                            <section className="gendoc-section">
                                <h2 className="gendoc-section-title">Manžel / manželka</h2>
                                <div className="gendoc-fields">
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Manžel/ka</span>
                                        <span className="gendoc-value">{funeral.d_wife_husband ? funeral.d_wife_husband : '-'}</span>
                                    </div>
                                    <div className="gendoc-field">
                                        <span className="gendoc-label">Rodné číslo</span>
                                        <span className="gendoc-value">{funeral.d_wife_husband_id ? funeral.d_wife_husband_id : '-'}</span>
                                    </div>
                                </div>
                            </section>

                            <div className="gendoc-legal">
                                <p className="gendoc-legal-lead">
                                    Týmto splnomocňujem pracovníkov pohrebnej služby <strong>{user.name} - {user.address}</strong> k
                                    nasledujúcim úkonom podľa zákona č. 131/2010 Z. z. o pohrebníctve
                                    v znení neskorších predpisov:
                                </p>
                                <p>
                                    <strong>Prevzatie:</strong> zosnulej osoby, urny, Listov o prehliadke
                                    mŕtveho (aj uchovanie kópie), OP a všetkých ostatných osobných dokumentov
                                    a dokladov, osobných vecí a cenností.<br/>
                                    <strong>Vybavenie:</strong> matričnej dokumentácie (§ 18 zákona NR
                                    SR č. 154/1994 Z.z. o matrikách v znení
                                    neskorších predpisov), faktúry a všetkých náležitostí spojených s pohrebom.<br/>
                                    <strong>Ďalšie:</strong> Odovzdanie kópií Listov o prehliadke
                                    mŕtveho zainteresovaným osobám (kňaz, správca
                                    domu smút...), marketingové účely, živé vysielanie z pohrebu, evidencia pohrebnej služby
                                    o zaobchádzaní s ľudskými pozostatkami a o pochovaní potratu/ľudského plodu, zabezpečenie
                                    pohrebu ľudských pozostatkov alebo ostatkov, zabezpečovanie kremácie ľudských pozostatkov,
                                    ostatkov alebo ľudského plodu, vybavovanie objednávok na viazanie vencov a kvetinovú
                                    smútočnú výzdobu na poslednú rozlúčku, poskytovanie služby v oblasti spracovania a prednesu
                                    nekrológu, povolenie na pochovanie.
                                </p>
                                <p>
                                    Prevádzkovateľ informoval dotknutú osobu o spôsobe, rozsahu a účelu spracúvania jej osobných
                                    údajov podľa Zákona č. 18/2018 Z.z., o ochrane osobných údajov v platnom znení a Nariadenia
                                    európskeho parlamentu a rady (EÚ) 2016/679 o ochrane fyzických osôb pri spracúvaní osobných
                                    údajov a o voľnom pohybe takýchto údajov. Prevádzkovateľ informoval dotknutú osobu aj o jej
                                    právach. Všeobecné nariadenie o ochrane osobných údajov priznáva dotknutej osobe niekoľko
                                    práv, ktoré si môže uplatniť priamo u nás (ako u subjektu, ktorý jej osobné údaje spracúva).
                                    Viac informácií o tom, aké sú Vaše práva a ako ich môžete uplatniť nájdete na webovom sídle
                                    prevádzkovateľa <strong>{user.web}</strong> v sekcii <strong> ochrana osobných údajov / GDPR</strong>. Vaša
                                    žiadosť na uplatnenie práv môže byť ústna, písomná, elektronická, prípadne podaná inými
                                    prostriedkami (odporúčame využiť najmä písomnú alebo elektronickú formu, aby bolo možné v
                                    prípadnom konaní o ochrane osobných údajov preukázať, že ste si práva uplatnili). <strong>Sme povinný vybaviť Vašu žiadosť bezodkladne najneskôr do jedného
                                    mesiaca od jej doručenia.</strong> V prípade
                                    akýchkoľvek otázok alebo nejasností nás môžete kontaktovať na telefónnom
                                    čísle <strong>{user.phone}</strong> alebo elektronicky
                                    prostredníctvom
                                    emailu <strong>{user.email_official}</strong>
                                </p>
                            </div>

                            <div className="gendoc-sign">
                                <div className="gendoc-sign__col">
                                    <div className="gendoc-sign__meta">
                                        V {funeral.signatures.location_of_delegation ? funeral.signatures.location_of_delegation
                                        : location} dňa {funeral.signatures.date_of_delegation ? new Date(funeral.signatures.date_of_delegation).toShortFormat()
                                        : date.toShortFormat()}.
                                    </div>
                                    {user.stamp &&
                                     <PrivateImage className="gendoc-sign__stamp" src={user.stamp} alt="Pečiatka"/>}
                                </div>
                                <div className="gendoc-sign__col gendoc-sign__col--right">
                                    {funeral.signatures.delegation_signature &&
                                    <PrivateImage className="gendoc-sign__sig" src={funeral.signatures.delegation_signature} alt="Podpis"/>}
                                    <div className="gendoc-sign__line">Podpis</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </PDFExport>
            </div>
        }
        return <></>
    }



    return (
        <Container maxWidth="lg" className={classes.seeMore}>
            <div className={classes.root}>
                <Paper className={fixedHeightPaper}>
                    <Grid container>
                        <Grid xs={12} sm={4} md={3} lg={3} item container>
                            <Toolbar>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    hidden={true}
                                    className={classes.button}
                                    onClick={() => {
                                        setSuccess(true)
                                    }}
                                >
                                    Späť na detaily
                                </Button>
                            </Toolbar>
                        </Grid>
                        <Grid xs={12} sm={8} md={9} lg={9} item container justifyContent='flex-end'>
                            <Toolbar className={`${classes.toolbarButtons} document-actions-toolbar`}>
                                <TextInput
                                    label="Miesto podpisu"
                                    name={'location'}
                                    value={location}
                                    onChange={handleLocation}
                                />
                                <DateInput
                                    label="Dátum podpisu"
                                    name={'date'}
                                    value={date}
                                    onChange={handleDate}
                                />
                                <ActionButton
                                    color="primary">
                                    <Tooltip title="Podpísať splnomocnenie">
                                        <BorderColorIcon
                                            fontSize="small"
                                            onClick={() => {
                                                handleShow();
                                            }}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <ActionButton
                                    color="primary">
                                    <Tooltip title="Pdf export">
                                        <PictureAsPdfIcon
                                            fontSize="small"
                                            onClick={handleExport}
                                        />
                                    </Tooltip>
                                </ActionButton>
                                <GeneratedDocumentEmailAction
                                    pdfRef={pdfRef}
                                    funeral={funeral}
                                    user={user}
                                />
                            </Toolbar>
                        </Grid>
                    </Grid>

                    <Divider/>
                    <Grid className={classes.marginTop}
                          container
                          spacing={0}
                          direction="column"
                          alignItems="center"
                          justifyContent="center"
                    >
                        {showDelegation()}
                    </Grid>
                </Paper>
            </div>
            <Popup
                title={'Podpis'}
                openPopup={show}
                setOpenPopup={setShow}
                maxW = 'xl'
                actions={<>
                    <Button color="primary" variant="outlined" onClick={() => {
                        setFullScreen(!fullScreen);
                    }
                    }>
                        {fullScreen ? 'Zmenšiť' : 'Zväčšiť'}
                    </Button>
                    <Button color="primary" variant="outlined" onClick={handleClear}>
                        Vyčistiť
                    </Button>
                    <Button color="primary" variant="outlined" onClick={handleSignature}>
                        Uložiť
                    </Button>
                </>}
            >
                <ReactSketchCanvas
                    ref={canvas}
                    strokeWidth={3}
                    strokeColor="blue"
                    style={{
                        border: "0.0625rem solid #9c9c9c",
                        borderRadius: "0.25rem",
                        display: "block",
                        margin: "0 auto",
                        touchAction: "none",
                        width: fullScreen ? convertSize(props.width) : props.width === 'xs' ? "min(300px, 100%)" : "min(500px, 100%)",
                        height: fullScreen ? 'min(600px, calc(100vh - 220px))' : props.width === 'xs' ? "125px" : "300px"
                    }}
                />
            </Popup>
            {success ? <Redirect to={{
                pathname: `/pohreb/${funeral_id.funeral_id}/info`,
                state: {from: props.location, number: 5}
            }}/> : <></>}
        </Container>
    )
}
export default withWidth()(DelegationGenerator);
